import React from 'react';
import { Image } from 'react-native';
import { Assets } from 'src/assets';
import { pixelScaler } from 'src/themes/Metrics';
import { RegularText, Row, SizedBox } from '../bases';

export const VehicleType = ({ image, service }: { image: string; service: string }) => {
  console.log({ image });
  return (
    <Row style={{ alignItems: 'center' }}>
      {/* <Image resizeMode="contain" source={{ uri: image }} style={{ width: pixelScaler(50), height: pixelScaler(32) }} /> */}
      <Image
        resizeMode="contain"
        source={{ uri: Assets.BusTicket }}
        style={{ width: pixelScaler(50), height: pixelScaler(32) }}
      />
      <SizedBox width="medium" />
      <RegularText fontWeight="bold">{service}</RegularText>
    </Row>
  );
  // if (vehicleType === 'bus') {
  //   return (
  //     <Row style={{ alignItems: 'center' }}>
  //       <Image
  //         resizeMode="contain"
  //         source={Assets.BusTicket}
  //         style={{ width: pixelScaler(50), height: pixelScaler(32) }}
  //       />
  //       <SizedBox width="medium" />
  //       <RegularText fontWeight="bold" textLang="bus" />
  //     </Row>
  //   );
  // }
  // return (
  //   <Row style={{ alignItems: 'center' }}>
  //     <Image
  //       resizeMode="contain"
  //       source={Assets.VanTicket}
  //       style={{ width: pixelScaler(50), height: pixelScaler(22) }}
  //     />
  //     <SizedBox width="medium" />
  //     <RegularText fontWeight="bold" textLang="van" />
  //   </Row>
  // );
};
